import { createWritableGenericContext } from '@luna/context';

const { useContext, createContextProvider } = createWritableGenericContext<
    Record<string, string> | undefined
>('RouteConfigContext');

export const createRouteRootConfigContext = createContextProvider;
export const useRouteRootConfigContext = useContext;
